import { AuthType } from '@corbado/shared-ui';
import React from 'react';
import { AuthFlow } from '../../components';
import FlowHandlerProvider from '../../contexts/FlowHandlerProvider';
const SignUp = ({ handleNavigationEvents, onSignedUp, navigateToLogin, initialAutoFocus = true, }) => {
    return (React.createElement(FlowHandlerProvider, { handleNavigationEvents: handleNavigationEvents, onLoggedIn: onSignedUp, onChangeFlow: navigateToLogin, initialFlowType: AuthType.SignUp },
        React.createElement(AuthFlow, { initialAutoFocus: initialAutoFocus })));
};
export default SignUp;
